// Sounds (owner 2026-10-17): made in code and played by the Web Audio API (sound/synth.ts) instead of the
// legacy <audio> elements with ogg / mp3 files, which started late. Banks `paper` (the default) and
// `plastic`; a stored legacy `wood` reads as `paper` (options/storage.ts). Every play is also announced as
// a `solitaire:sound` event on window ({ bank, name }; the e2e helpers record what the player hears from
// it), before the audio is tried, so it is reported even where the browser blocks or has no audio.
import type { SoundBank } from '../options/storage';
import { play, prepare, startBuilding, type DealShape } from './synth';

export type SoundName = 'drop' | 'deal' | 'win';
let bank: SoundBank = 'off';

export function setSoundBank(next: SoundBank): void {
  bank = next;
  if (next !== 'off') prepare(next);
}

/** The first deal is on its way: the sounds may be built now (synth.ts `prepare`). */
export const startSoundBuilding = (): void => startBuilding();

/** `shape`: the card's flight (a drop) or the deal's cards and timing: the sound follows the view's cards. */
export function playSound(name: SoundName, shape?: Partial<DealShape>): void {
  if (bank === 'off') return;
  try {
    dispatchEvent(new CustomEvent('solitaire:sound', { detail: { bank, name } }));
  } catch {
    /* ignore */
  }
  play(bank, name, shape);
}

export const currentSoundBank = (): SoundBank => bank;

const LAST_SOUND_KEY = 'solitaire_storage:options:last-sound';

/** Remember the last bank that was on, so the footer toggle can bring it back (Q-FOOT-1). */
export function rememberLastSound(bank: 'paper' | 'plastic'): void {
  try {
    localStorage.setItem(LAST_SOUND_KEY, bank);
  } catch {
    /* no storage */
  }
}

export function lastSound(): 'paper' | 'plastic' {
  try {
    return localStorage.getItem(LAST_SOUND_KEY) === 'plastic' ? 'plastic' : 'paper';
  } catch {
    return 'paper';
  }
}
